import axios from "axios";
import * as actionType from "../../constant/actionType";
export const ResendEmailVerification = (apidata) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/ResendEmailVerification`,
      data:  apidata ,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};